import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import translations from "../utils/translations";
import { getBrokerInformation } from "../store/broker";
import { useDispatch, useSelector } from "react-redux";
import { getBrokerageInformation, getDetails } from "../store/brokerage";

const BrokerAdminNavigation = (props) => {
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;
  const styles = {
    className: "list-group-item list-group-item-action",
    activeClassName:
      "list-group-item list-group-item-light list-group-item-action active",
  };

  let links = [
    {
      className:
        props.active === "details" ? styles.activeClassName : styles.className,
      to: "/brokeradmin/details",
      name: translationsBrokerAdmin.brokerageDetails,
    },
    {
      className:
        props.active === "user" ? styles.activeClassName : styles.className,
      to: "/brokeradmin/user",
      name: translationsBrokerAdmin.userManagement,
    },
    {
      className:
        props.active === "insuredcontacts"
          ? styles.activeClassName
          : styles.className,
      to: "/brokeradmin/insuredcontacts",
      name: translationsBrokerAdmin.insurerContacts,
    },
    {
      className:
        props.active === "bms" ? styles.activeClassName : styles.className,
      to: "/brokeradmin/bms",
      name: translationsBrokerAdmin.bmsCredentials,
    },
    {
      className:
        props.active === "branding" ? styles.activeClassName : styles.className,
      to: "/brokeradmin/branding",
      name: translationsBrokerAdmin.logoAndColors,
    },
    {
      className:
        props.active === "aboutus" ? styles.activeClassName : styles.className,
      to: "/brokeradmin/aboutus",
      name: translationsBrokerAdmin.aboutUs,
    },
    {
      className:
        props.active === "payment" ? styles.activeClassName : styles.className,
      to: "/brokeradmin/payment",
      name: translationsBrokerAdmin.payment,
    },
    {
      className:
        props.active === "transaction"
          ? styles.activeClassName
          : styles.className,
      to: "/brokeradmin/transaction",
      name: translationsBrokerAdmin.transaction,
    },
    {
      className:
        props.active === "groupmanagement"
          ? styles.activeClassName
          : styles.className,
      to: "/brokeradmin/groupmanagement",
      name: translationsBrokerAdmin.groupManagement,
    },
    {
      className:
        props.active === "ssoDashboard"
          ? styles.activeClassName
          : styles.className,
      to: "/brokeradmin/ssoDashboard",
      name: translationsBrokerAdmin.authManagement,
    }
    

    // Uncomment and add translations when needed
    // {
    //     className: props.active === "apistatus" ? styles.activeClassName : styles.className,
    //     to: '/brokeradmin/apistatus',
    //     name: translationsBrokerAdmin.customizeAPIs,
    // },
    // {
    //     className: props.active === "userdata" ? styles.activeClassName : styles.className,
    //     to: '/brokeradmin/userdata',
    //     name: translationsBrokerAdmin.yourData,
    // },
    // {
    //     className: props.active === "paymentdetails" ? styles.activeClassName : styles.className,
    //     to: '/brokeradmin/paymentdetails',
    //     name: translationsBrokerAdmin.managePayment,
    // },
  ];
  const information = useSelector(getBrokerageInformation);
  let brokerage_code = props.broker?.information?.brokeragecode;
  const dispatch = useDispatch();
  React.useEffect(() => {
    let data = { brokerage_code };
    dispatch(getDetails(data));
  }, []);
  if (!information.otherinfo?.bms?.brokeragecode) {
    links = links.filter((x) => x.name != "BMS Credentials");
  }

  return (
    <div>
      <ul className="list-group" style={{ listStyle: "none" }}>
        {links.map((link, index) => (
          <li key={index} style={{ fontFamily: "GibsonSemiBd" }}>
            <Link
              style={{ paddingLeft: "30px" }}
              className={link.className}
              role="button"
              to={link.to}
            >
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BrokerAdminNavigation;
